import { render, staticRenderFns } from "./PurchaseModule.vue?vue&type=template&id=5cdbf416"
import script from "./PurchaseModule.vue?vue&type=script&lang=js"
export * from "./PurchaseModule.vue?vue&type=script&lang=js"
import style0 from "./PurchaseModule.vue?vue&type=style&index=0&id=5cdbf416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports